"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_GRID = void 0;
const colors_1 = require("../styles/colors");
exports.DATA_GRID = {
    styleOverrides: {
        root: {
            borderStyle: 'none',
        },
        row: {
            '&:hover': {
                cursor: 'pointer',
                backgroundColor: '#eafaff52',
            },
            '&.Mui-selected': {
                backgroundColor: `${colors_1.$blueRowGridSelected}`,
            },
            borderBottom: `1px solid ${colors_1.$grey10}`,
            '&:first-of-type': {
                borderTop: `1px solid ${colors_1.$grey10}`,
            },
            '&.with-background': {
                backgroundColor: colors_1.$lightBlue,
                border: 'none',
                borderRadius: '8px',
                '&.Mui-selected': {
                    backgroundColor: colors_1.$secondaryLessBlue,
                },
            },
            '&.status-ok': {
                borderLeft: `8px solid ${colors_1.$darkGreen}`,
                borderTopLeftRadius: '4px',
                borderBottomLeftRadius: '4px',
            },
            '&.status-ko': {
                borderLeft: `8px solid ${colors_1.$darkRed}`,
                borderTopLeftRadius: '4px',
                borderBottomLeftRadius: '4px',
            },
            '&.status-expire': {
                borderLeft: `8px solid ${colors_1.$orange}`,
                borderTopLeftRadius: '4px',
                borderBottomLeftRadius: '4px',
            },
            '&.status-basic': {
                borderLeft: `8px solid ${colors_1.$primaryBrand}`,
                borderTopLeftRadius: '4px',
                borderBottomLeftRadius: '4px',
            },
        },
        cell: {
            borderStyle: 'none',
            '&:focus': {
                outline: 'none',
            },
            '&.status-ok': {
                color: colors_1.$darkGreen,
            },
            '&.status-ko': {
                color: colors_1.$darkRed,
            },
            '&.status-expire': {
                color: colors_1.$orange,
            },
            '&.quantity': {
                fontWeight: 500,
            },
        },
        footerContainer: {
            borderStyle: 'none',
        },
        columnHeader: {
            '&:focus': {
                outline: 'none',
            },
            '&.with-status': {
                borderLeft: `8px solid ${colors_1.$primaryWhite}`,
            },
            textTransform: 'uppercase',
        },
        columnHeaders: {
            borderStyle: 'none',
        },
        columnSeparator: {
            display: 'none',
        },
    },
};
